import React, { useEffect, useState } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import Select from 'react-select'
import useSessionStorage from '../../hooks/useSessionStorage'
import useAppNavigation from '../../hooks/useAppNavigation'
import { initialFields } from '../../consts'

export default function Raza({ label, title, required = true }) {
  const {
    control,
    register,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext()

  const [breeds, setBreeds] = useState(null)

  const [storageData, setStorageData] = useSessionStorage(
    'app_data',
    initialFields
  )

  const { currentStep, setCurrentStep } = useAppNavigation()

  const handleChange = ({ value, label }) => {
    setValue('MCCRETARITAG.CodRaza', value)
    setValue('MCCRETARITAG.Raza', label)
    clearErrors('MCCRETARITAG.Raza')
    setStorageData(getValues())
  }

  const getBreedsPYS = async () => {
    const data = { action: 'get_razas_pys' }
    const response = await fetch(
      `${window.location.protocol}//${window.location.host}/wp-admin/admin-ajax.php`,
      {
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(data).toString(),
      }
    ).then((response) => response.json())
    // console.log(response)

    if (response) {
      const options = Object.values(response?.Razas).map((breed) => ({
        value: breed['CodRaza'],
        label: breed['DesRaza'],
      }))
      setBreeds(options)
    }
  }

  const getTarificarPYS = async () => {
    console.log('PYS -> Tarificar. Esperando respuesta...')

    const data = {
      action: 'get_tarificar_pys',
      MCCRETARITAG: JSON.stringify(getValues('MCCRETARITAG')),
      MCCPERSTAG: JSON.stringify(getValues('MCCPERSTAG')),
    }

    const response = await fetch(
      `${window.location.protocol}//${window.location.host}/wp-admin/admin-ajax.php`,
      {
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(data).toString(),
      }
    ).then((response) => response.json())
    if (response) {
      if (response?.STari?.SModa) {
        if (parseFloat(response?.STari?.SModa?.PrimaTotal) > 90) {
          setCurrentStep({ ...currentStep, id_product: 133 })
          setValue('dangerousBreed', 'true')
          setStorageData(getValues())
        } else {
          setCurrentStep({ ...currentStep, id_product: 20 })
          setValue('dangerousBreed', 'false')
          setStorageData(getValues())
        }
      }
      console.log('getTarificarPYS', response)
      return response
    }
  }

  useEffect(() => {
    getBreedsPYS()
  }, [])

  return (
    <div className="form-field">
      {title && <span>{title}</span>}
      <div className="form-group">
        <label htmlFor="MCCRETARITAG.Raza">{label || 'Raza'}</label>

        <input
          className="form-control"
          type="hidden"
          {...register('MCCRETARITAG.Raza', {
            required: required === true ? 'La raza es obligatoria.' : false,
            pattern: {
              value: /^[a-zA-ZÀ-ÖØ-öø-ÿ -]+$/i,
              message: 'Has introducido caracteres no permitidos.',
            },
            maxLength: {
              value: 150,
              message: 'La raza es demasiado larga.',
            },
          })}
        />

        {breeds && (
          <Controller
            control={control}
            name="MCCRETARITAG.CodRaza"
            rules={{
              required: {
                value: true,
                message: 'Tiene que seleccionar una raza.',
              },
            }}
            render={({ field, value, name, ref }) => (
              <Select
                id="MCCRETARITAG.CodRaza"
                name={field.name}
                className={`react-select-container${
                  errors.MCCRETARITAG?.Raza ? ' hasError' : ''
                }`}
                classNamePrefix="react-select"
                placeholder="Selecciona una raza..."
                inputRef={field.ref}
                options={breeds}
                value={breeds.find(
                  (c) => c.value === getValues('MCCRETARITAG.CodRaza')
                )}
                onChange={(val) => {
                  handleChange(val)
                  getTarificarPYS()
                }}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 4,
                  colors: {
                    ...theme.colors,
                    //   //after select dropdown option
                    //   primary50: 'blue',
                    //   //Border and Background dropdown color
                    primary: '#00b3ba',
                    //   //Background hover dropdown color
                    //   // primary25: "yellow",
                    //   //Background color
                    //   // neutral0: "black",
                    //   //Border before select
                    //   // neutral20: "#CAFFCA",
                    //   //Hover border
                    //   neutral30: '#ccc',
                    //   //No options color
                    //   // neutral40: "#CAFFCA",
                    //   //Select color
                    // neutral50: 'pink',
                    //   //arrow icon when click select
                    neutral60: '#00b3ba',
                    //   //Text color
                    //   neutral80: '#222',
                  },
                })}
              />
            )}
          />
        )}

        {errors.MCCRETARITAG?.Raza && (
          <div className="error">{errors.MCCRETARITAG.Raza.message}</div>
        )}
      </div>
    </div>
  )
}
